import type { ActivityEvent } from '../types/activity';

export const activityEvents: ActivityEvent[] = [
  // Vesting
  { id: 'a1', conditionId: 'c1', kind: 'status', actorId: 'nd', createdAt: '2026-06-24T09:02:00', from: 'none', to: 'new' },
  { id: 'a2', conditionId: 'c1', kind: 'status', actorId: 'nd', createdAt: '2026-07-13T10:12:00', from: 'new', to: 'requested' },
  { id: 'a3', conditionId: 'c1', kind: 'borrower_email', actorId: 'nd', createdAt: '2026-07-13T10:13:00', borrowerFacing: true },
  { id: 'a4', conditionId: 'c1', kind: 'eta', actorId: 'mc', createdAt: '2026-10-01T16:40:00', to: '2026-10-08' },
  { id: 'a5', conditionId: 'c1', kind: 'conditions_sent', actorId: 'nd', createdAt: '2026-10-09T15:18:00', borrowerFacing: true },

  // Hazard Insurance
  { id: 'a6', conditionId: 'c2', kind: 'status', actorId: 'mc', createdAt: '2026-10-09T08:30:00', from: 'none', to: 'new' },
  { id: 'a7', conditionId: 'c2', kind: 'owner', actorId: 'mc', createdAt: '2026-10-09T08:31:00', from: 'mc', to: 'nd' },

  // Bank Statements
  { id: 'a8', conditionId: 'c3', kind: 'status', actorId: 'nd', createdAt: '2026-10-02T11:05:00', from: 'new', to: 'requested' },
  { id: 'a9', conditionId: 'c3', kind: 'borrower_email', actorId: 'nd', createdAt: '2026-10-02T11:06:00', borrowerFacing: true },
  { id: 'a10', conditionId: 'c3', kind: 'eta', actorId: 'nd', createdAt: '2026-10-02T11:07:00', to: '2026-10-09' },
  {
    id: 'a11',
    conditionId: 'c3',
    kind: 'document_uploaded',
    actorId: 'borrower',
    createdAt: '2026-10-08T19:44:00',
    fileNames: ['Chase_Statement_Jul_4821.pdf', 'Chase_Statement_Aug_4821.pdf', 'Chase_Statement_Sep_4821.pdf'],
  },
  { id: 'a12', conditionId: 'c3', kind: 'status', actorId: 'nd', createdAt: '2026-10-10T09:12:00', from: 'requested', to: 'review' },

  // Letter of Explanation
  { id: 'a13', conditionId: 'c4', kind: 'status', actorId: 'nd', createdAt: '2026-10-10T08:50:00', from: 'new', to: 'requested' },
  {
    id: 'a14',
    conditionId: 'c4',
    kind: 'document_linked',
    actorId: 'nd',
    createdAt: '2026-10-10T14:22:00',
    fileNames: ['Credit_Inquiry_LOE.pdf'],
  },
  { id: 'a15', conditionId: 'c4', kind: 'status', actorId: 'nd', createdAt: '2026-10-10T14:23:00', from: 'requested', to: 'review' },

  // Verification of Employment
  { id: 'a16', conditionId: 'c5', kind: 'status', actorId: 'nd', createdAt: '2026-09-23T10:00:00', from: 'new', to: 'requested' },
  { id: 'a17', conditionId: 'c5', kind: 'document_uploaded', actorId: 'nd', createdAt: '2026-10-05T13:15:00', fileNames: ['WVOE_Acme_Corp.pdf'] },
  { id: 'a18', conditionId: 'c5', kind: 'status', actorId: 'nd', createdAt: '2026-10-06T09:40:00', from: 'review', to: 'cleared' },

  // Initial Disclosures
  { id: 'a19', conditionId: 'c7', kind: 'status', actorId: 'mc', createdAt: '2026-10-05T12:00:00', from: 'requested', to: 'review' },

  // Title Commitment
  { id: 'a20', conditionId: 'c9', kind: 'status', actorId: 'pp', createdAt: '2026-10-03T09:30:00', from: 'new', to: 'requested' },
  { id: 'a21', conditionId: 'c9', kind: 'eta', actorId: 'pp', createdAt: '2026-10-08T11:21:00', from: '2026-10-10', to: '2026-10-16' },
  { id: 'a22', conditionId: 'c9', kind: 'owner', actorId: 'nd', createdAt: '2026-10-03T09:31:00', from: 'nd', to: 'pp' },
];
